import { createAsyncThunk } from '@reduxjs/toolkit';
import { TELERADIOLOGY_LIST_API_URL } from '@custom/constant';
import { TeleraidologyListArgs } from '@custom/Utils/constants/interfaces';

// Async thunk for fetching teleraidology customer list
export const fetchTeleraidologyList = createAsyncThunk(
  'customer/fetchTeleraidologyList',
  async ({ limit, pageNumber, search }: TeleraidologyListArgs, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(TELERADIOLOGY_LIST_API_URL, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          limit: limit,
          pageNumber: pageNumber,
          search: search,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch teleraidology customer list');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default fetchTeleraidologyList;
